import { memo } from "react";
import { Outlet } from "react-router-dom";

import CenterContentPageHolder from "../../components/structure/CenterContentPageHolder";

function OrganizationRoot() {
   return (
      <CenterContentPageHolder withDecoration>
         <Outlet />
      </CenterContentPageHolder>
   );
}

export default memo(OrganizationRoot);
